import { EarningsPeriod } from '@api/api/earnings';
import { Entity } from '@api/api/entity-schema';
import { getCalendarQuarterInfo } from '@terminal/views/theme-overview/tab-content/earnings/utils/utils';

import { IndustryThemesTable } from './IndustryThemesTable';
import styles from './IndustryThemesTable.module.scss';
import { TopCompetitors } from './top-competitors/TopCompetitors';

export interface PeerComparisonProps {
  entity: Entity;
  activeReportingPeriod: EarningsPeriod;
}

export const PeerComparison = ({
  entity,
  activeReportingPeriod,
}: PeerComparisonProps) => {
  const { startDate, endDate } = getCalendarQuarterInfo(
    new Date(activeReportingPeriod.reporting_date)
  );

  return (
    <div
      data-testid="peer-comparison-panel"
      className={styles.peerComparisonPanel}
    >
      <TopCompetitors
        entity={entity}
        activeReportingPeriod={activeReportingPeriod}
      />
      <IndustryThemesTable entity={entity} timeframe={{ startDate, endDate }} />
    </div>
  );
};
